import React from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import AllWorkReportList from '../components/AllWorkReportList'

function WorkReportDashboardPage() {
  return (
    <AppLayout>
      <div className='container-fluid'>
        <AllWorkReportList/>
      </div>
    </AppLayout>
  )
}

export default WorkReportDashboardPage